import React, { Component } from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
// import BootstrapRow from '../../../hoc/BootstrapRow';
//import FormInputFields from '../../../Components/FormInputFields';
// import BootstrapColumn from '../../../hoc/BootstrapColumn';
// import { getCurrentModuleId } from '../../../Utils/UserFunctions';
class Pagination extends Component {
    constructor(props) {
      super(props);
      this.state ={
        currentPage:(this.props.page+1),
        perPage:this.props.perPage,
        totalRecords:this.props.totalRecords,
      }
    }
    componentDidUpdate (prevProps){
        if(prevProps !== this.props) {
            setTimeout(() => {
                this.setState(
                    { currentPage:(this.props.page+1),
                      perPage:this.props.perPage,
                      totalRecords:this.props.totalRecords,
                    });
              }, 100)
        }
    }
    paginationOnChangeHandler(page){
        const pagination = {
            ...this.props,
            page:(page-1),
                
        }
        this.props.recordsChangeHandler(pagination);
    }
    perPageOnChangeHandler= (value) =>{
        const pagination = {
          ...this.props,
          page:0,
          perPage:value
        }
        this.props.recordsChangeHandler(pagination,true);
    }

    render () {
        let currentPage = this.state.currentPage;
        let perPage = this.state.perPage;
        const totalRecords = this.state.totalRecords;
        const totalPages = Math.ceil(totalRecords/perPage);
        var startPage = 0, endPage =0;
        // console.log(this.props);
        currentPage = currentPage || 1;
        // default page size is 10
        perPage = perPage || 5;
        perPage = Number(perPage);
        // console.log(this.props);
        if (totalPages <= 5) {
            // less than 5 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 5 total pages so calculate start and end pages
            if (currentPage <= 4) {
                startPage = 1;
                endPage = 5;
            } else if (currentPage + 3 >= totalPages) {
                startPage = totalPages - 4;
                endPage = totalPages;
            } else {
                startPage = currentPage - 2;
                endPage = currentPage + 2;
            }
        }
        // calculate start and end item indexes
        var startIndex = (currentPage - 1) * perPage + 1;
        var endIndex = Math.min(startIndex + perPage - 1, totalRecords);
        var pages = [...Array((endPage + 1) - startPage).keys()].map(i => startPage + i);
        
        const perPageItem = 
        {
          type:'PickList',
          isDefault:true,
          label:{
            text:"",
            className:"form-control form-control-sm",
          },
          isMandatory:false,
          key:'showEntries',
          value:this.props.perPage,
          options:[
            {id:10,value:10},
            {id:25,value:25},
            {id:50,value:50},
            {id:100,value:100},
          ],
          className:"form-control-sm",
          attributes:{
              style:{}
          },
          changeHandler:this.perPageOnChangeHandler
        }
        return (
        
            <Wrp>

                {
                  (totalRecords>0)?
                    <div className="dataTables_paginate paging_simple_numbers">
                        <ul className="pagination">
                          <li className={currentPage === 1 ? "paginate_button page-item previous disabled" : "paginate_button page-item previous"} id="add-row_previous"><a aria-controls="add-row" data-dt-idx="0" tabIndex="0" className="page-link" title="First" onClick={() => this.paginationOnChangeHandler(1)}><i className="fas fa-angle-double-left"></i></a>
                          </li>
                          <li className={currentPage === 1 ? "paginate_button page-item previous disabled" : "paginate_button page-item previous"} id="add-row_previous"><a aria-controls="add-row" data-dt-idx="0" tabIndex="0" className="page-link" title="Previous" onClick={() => this.paginationOnChangeHandler(currentPage - 1)}><i className="fas fa-angle-left"></i></a>
                          </li>
                            {
                                pages.map((page, index) =>{
                                    // console.log(currentPage,page)
                                    return(
                                        <li key={index} className={currentPage === (page) ? "paginate_button page-item active" : "paginate_button page-item"}>
                                        {currentPage === page ? 
                                        <a aria-controls="add-row" data-dt-idx="1" tabIndex="0" className="page-link" >{page}</a>
                                        :
                                        <a aria-controls="add-row" data-dt-idx="1" tabIndex="0" className="page-link" onClick={() => this.paginationOnChangeHandler(page)}>{page}</a>
                                        }
                                    </li>
                                    )
                                })
                            }
                          <li className={currentPage === totalPages ? "paginate_button page-item next disabled" : "paginate_button page-item next"} id="add-row_next"><a aria-controls="add-row" data-dt-idx="3" tabIndex="0" className="page-link" title="Next" onClick={() => this.paginationOnChangeHandler(currentPage + 1)}><i className="fas fa-angle-right"></i></a>
                          </li>
                          <li className={currentPage === totalPages ? "paginate_button page-item next disabled" : "paginate_button page-item next"} id="add-row_next"><a aria-controls="add-row" data-dt-idx="3" tabIndex="0" className="page-link" title="Last" onClick={() => this.paginationOnChangeHandler(totalPages)}><i className="fas fa-angle-double-right"></i></a>
                          </li>
                        </ul>
                    </div>
                  :
                  ''  
                }                                        
            </Wrp>
            
        )
    }
}

export default Pagination;